import QuickLaunch from './general/QuickLaunch'
import ToDoList from './general/ToDoList'
import Debug from './superAdmin/Debug'
import UsersOnline from './superAdmin/UsersOnline'

/* Sample template from Nimbus 2
import MySalesRevenue from './quotation/MySalesRevenue'
import TotalSalesRevenue from './quotation/TotalSalesRevenue'
import MyQuotationsIssued from './quotation/MyQuotationsIssued'
import TotalQuotationsIssued from './quotation/TotalQuotationsIssued'
import MyInforcedProposals from './quotation/MyInforcedProposals'
import TotalInforcedProposals from './quotation/TotalInforcedProposals'
import PendingMtr from './quotation/PendingMtr'
import RevenueChart from './quotation/RevenueChart'
import MyRevenueChart from './quotation/MyRevenueChart'
import InforceChart from './quotation/InforceChart'
import MyInforceChart from './quotation/MyInforceChart'
import ConversionChart from './quotation/ConversionChart'
import MyConversionChart from './quotation/MyConversionChart'
*/
// Template widget for O5
import MyRevenueSalesChart from './core/MyRevenueSalesChart'
import MyClaimsSummaryChart from './core/MyClaimsSummaryChart'
import MyClaimsNotifications from './core/MyClaimsNotifications'

// X axis based on 12 grid scale
// Y axis "row height" is 150px
// Above values follow DashBoard grid layout value

// key - identifier of the widget (have to be the same name as the component - detection purpose)
// name - Name of the widget
// minW - min width of the widget (based on grid scale)
// defW - def width of the widget (when newly placed in dashboard, what W should it be)
// minH - min height of the widget (based on "row height" multiplier)
// defH - def height of the widget
// isResizable - ability to resize
// component - Component file of the widget

export const widgets = {
  quickLaunch: { name: 'Quick Launch', minW: 3, minH: 1, defW: 4, defH: 3, isResizable: true, component: QuickLaunch },
  toDoList: { name: 'To Do List', minW: 3, minH: 3, defW: 3, defH: 3, isResizable: true, component: ToDoList },
  debug: { name: 'Debug Widget', minW: 2, minH: 1, defW: 2, defH: 2, isResizable: true, component: Debug },
  usersOnline: { name: 'Users Online', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: UsersOnline },
  /* Sample template from Nimbus 2
  mySalesRevenue: { name: 'My Sales Revenue', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: MySalesRevenue },
  totalSalesRevenue: { name: 'Total Sales Revenue', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: TotalSalesRevenue },
  totalQuotationsIssued: { name: 'Total Quotations Issued', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: TotalQuotationsIssued },
  myQuotationsIssued: { name: 'My Quotations Issued', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: MyQuotationsIssued },
  myInforcedProposals: { name: 'My Inforced Proposals', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: MyInforcedProposals },
  totalInforcedProposals: { name: 'Total Inforced Proposals', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: TotalInforcedProposals },
  pendingMtr: { name: 'Pending Motor Quotes/Proposals', minW: 3, minH: 1, defW: 3, defH: 1, isResizable: false, component: PendingMtr },
  revenueChart: { name: 'Total Revenue Chart', minW: 6, minH: 4, defW: 6, defH: 4, isResizable: true, component: RevenueChart },
  myRevenueChart: { name: 'My Revenue Chart', minW: 6, minH: 4, defW: 6, defH: 4, isResizable: true, component: MyRevenueChart },
  inforceChart: { name: 'Total Inforce Chart', minW: 6, minH: 4, defW: 6, defH: 4, isResizable: true, component: InforceChart },
  myInforceChart: { name: 'My Inforce Chart', minW: 6, minH: 4, defW: 6, defH: 4, isResizable: true, component: MyInforceChart },
  conversionChart: { name: 'Total Conversion Chart', minW: 5, minH: 4, defW: 5, defH: 4, isResizable: true, component: ConversionChart },
  myConversionChart: { name: 'My Conversion Chart', minW: 5, minH: 4, defW: 5, defH: 4, isResizable: true, component: MyConversionChart },
  */
  myRevenueSalesChart: { name: 'My Revenue Sales Chart', minW: 6, minH: 3, defW: 6, defH: 4, isResizable: true, component: MyRevenueSalesChart },
  myClaimsSummaryChart: { name: 'Claims Status Summary', minW: 6, minH: 3, defW: 6, defH: 4, isResizable: true, component: MyClaimsSummaryChart },
  myClaimsNotifications: { name: 'My Claims Notifications', minW: 6, minH: 3, defW: 6, defH: 4, isResizable: true, component: MyClaimsNotifications }
}
